<!--  -->
<template>
  <div class="vip">
    <div class="box">
      <div class="title">
        <span>成为订阅会员，享受更多特权</span>
        <i class="el-icon-close close" @click="close()"></i>
      </div>
      <div class="content">
        <div class="left">
          <p class="name">选择方案</p>
          <button class="more" @click="toDetail">
            查看订阅会员专属服务
            <i class="el-icon-arrow-right"></i>
          </button>
          <ul>
            <li
              v-for="item in list"
              :key="item.paprid"
              :class="active==item.paprid?'active':''"
              @click="selectPrice(item)"
            >
              <img src="../assets/mark.png" alt v-if="item.paprid==4" />
              <span class="month">{{item.specification}}个月</span>
              <span class="price">￥{{item.pp_amounty}}</span>
              <span class="sale">￥{{item.pp_amounts}}</span>
            </li>
          </ul>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="right">
          <div class="user">
            <img :src="userInfo.head" alt />
            <div class="info">
              <p class="name">{{userInfo.username}}</p>
              <p class="grade">{{userInfo.userPrivilege != null?'订阅会员':'普通会员'}}</p>
            </div>
          </div>
          <ul>
            <li>
              <span class="txt1">方案名称</span>
              <span class="txt2">订阅会员</span>
            </li>
            <li>
              <span class="txt1">开通时长</span>
              <span class="txt2">{{infoObj.specification}}个月</span>
            </li>
            <li>
              <span class="txt1">金额</span>
              <span class="txt2">￥{{infoObj.pp_amounts}}</span>
            </li>
          </ul>
          <button :class="!checked?'activeBtn':'ljbtn'" :disabled="!checked" @click="open">立即开通</button>
          <el-checkbox v-model="checked">
            <p>
              同意
              <a
                href="http://www.qxchuhai.com/publicPage?numbercms=102623"
                target="_blank"
              >《订阅会员服务协议》</a>
            </p>
          </el-checkbox>
        </div>
      </div>
    </div>
    <div class="mask" v-show="wxcodeShow">
      <div class="wxbox">
        <i class="el-icon-close" @click="codeClose"></i>
        <div id="qrcode" ref="qrcode"></div>
        <p class="txt">微信扫码支付</p>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import tool from '../tool/tool'
import { API_1, Global } from '@/conf/api'
import QRCode from 'qrcodejs2'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'vipMask',
  components: {},
  props: ['userInfo'],
  data() {
    //这里存放数据
    return {
      active: 4,
      list: [],
      checked: true,
      infoObj: {},
      wxurl: '',
      wxcodeShow: false,
      passcode: '',
      lockReconnect: false, //是否真正建立连接
      timeout: 58 * 1000, //秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    codeClose() {
      this.wxcodeShow = false
      this.ws.close()
    },
    getPrice() {
      let params = this.$qs.stringify({
        productCode: 1,
      })
      this.axios
        .post(API_1 + Global.VIPprice, params, {})
        .then((res) => {
          this.list = res.data.data
          this.infoObj = res.data.data[0]
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
    selectPrice(item) {
      this.active = item.paprid
      this.infoObj = item
    },
    open() {
      let params = this.$qs.stringify({
        paprid: this.infoObj.paprid,
        iudser: tool.getCookie('user'),
        cuosdeer: tool.getCookie('qxchuhai'),
      })
      this.axios
        .post(API_1 + Global.vippay, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          //this.wxurl = res.data.data.data
          this.wxcodeShow = true
          this.passcode = res.data.msg
          document.getElementById('qrcode').innerHTML = ''
          new QRCode('qrcode', {
            text: res.data.data, // 二维码内容
            width: 150,
            height: 150,
            render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          })
          this.wxcode()
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
    wxcode() {
      //'ws://192.168.2.198:8082/fy/socket/qx-vip'
      let wsuri = 'ws://182.61.21.235/fy/socket/qx-vip'
      //192.168.0.196:8082 //182.61.21.235
      this.ws = new WebSocket(wsuri)
      this.ws.onopen = this.onopen
      this.ws.onmessage = this.onmessage
      this.ws.onclose = this.onclose
      this.ws.onerror = this.onerror
    },
    reconnect() {
      //重新连接
      var that = this
      if (that.lockReconnect) {
        return
      }
      that.lockReconnect = true
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum)
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.wxcode()
        that.lockReconnect = false
      }, 5000)
    },
    reset() {
      //重置心跳
      var that = this
      //清除时间
      clearTimeout(that.timeoutObj)
      clearTimeout(that.serverTimeoutObj)
      //重启心跳
      that.start()
    },
    start() {
      //开启心跳
      var self = this
      self.timeoutObj && clearTimeout(self.timeoutObj)
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj)
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.ws.readyState == 1) {
          //如果连接正常
          self.ws.send('xtqxch')
        } else {
          //否则重连
          self.reconnect()
        }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.ws.close()
        }, self.timeout)
      }, self.timeout)
    },
    onopen() {
      //开启心跳
      this.start()
      this.ws.send(this.passcode)
    },
    onmessage(e) {
      //获取websocket推送的数据
      console.log(e)
      let msg = e.data
      let obj = JSON.parse(msg)
      switch (obj.status) {
        case 0:
          this.$message({
            message: '验证失败，请重试',
            type: 'warning',
            offset: 100,
          })
          break
        case 1:
          this.$message({
            message: '支付成功',
            type: 'success',
            offset: 100,
          })
          this.wxcodeShow = false
          this.ws.close()
          location.reload()
          break
        case 3:
          this.reset()
          break
      }
    },
    onclose(e) {
      console.log('连接关闭')
      clearTimeout(this.timeoutObj)
      clearTimeout(this.serverTimeoutObj)
      //重连
      //this.reconnect()
    },
    onerror(e) {
      console.log('出现错误')
      //重连
      //this.reconnect()
    },
    toDetail() {
      this.$router.push({
        path: '/vip',
      })
    },
    close() {
      this.$emit('closeVIP', false)
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPrice()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
  //@import url(); 引入公共css类
  .vip {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    .mask {
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.3);
      z-index: 999999;
      .wxbox {
        background: #fff;
        width: 300px;
        height: 300px;
        border-radius: 5px;
        margin: -150px auto 0;
        padding-top: 30px;
        box-sizing: border-box;
        position: relative;
        top: 50%; /*偏移*/
        i {
          float: right;
          margin-right: 10px;
          margin-top: -19px;
        }
        #qrcode {
          margin: 0 auto 30px;
          width: 150px;
          height: 150px;
        }
        .txt {
          background-image: url('../assets/wx.png');
          background-position: 35px 10px;
          background-repeat: no-repeat;
          background-size: 20px 20px;
          height: 40px;
          line-height: 40px;
          color: #04cb64;
          background-color: #d3f1cb;
          width: 200px;
          margin: 0 auto;
          border-radius: 20px;
          padding: 0 20px 0 45px;
          font-size: 16px;
          margin-bottom: 20px;
          text-align: center;
          box-sizing: border-box;
        }
      }
    }
    .box {
      width: 910px;
      height: 420px;
      background: linear-gradient(90deg, #f8ddbf, #d9b084);
      border-radius: 10px 10px 0px 0px;
      margin: -210px auto 0;
      position: relative; /*脱离文档流*/
      top: 50%; /*偏移*/
      .title {
        color: #63370c;
        height: 60px;
        line-height: 60px;
        padding: 0 40px;
        font-size: 18px;
        font-weight: 400;
        .close {
          float: right;
          margin-top: 20px;
          color: #b57230;
          &:hover {
            color: #ffeedc;
          }
        }
      }
      .content {
        background: #fff;
        height: 360px;
        padding: 30px 40px 0;
        .el-divider {
          height: 390px;
          margin-top: -30px;
          position: absolute;
        }
        .left {
          width: 560px;
          display: inline-block;
          padding-right: 40px;
          box-sizing: border-box;
          text-align: left;
          ul {
            width: 560px;
            display: flex;
            flex-wrap: wrap;
            justify-content: left;
            margin-top: 35px;
            .active {
              background-color: #fdf5ed;
              border: 2px solid #e6c29c;
              background-image: url('../assets/rightdown.png');
              background-position: 220px 55px;
              background-size: 35px 35px;
              background-repeat: no-repeat;
            }
            li {
              width: 260px;
              height: 92px;
              background: #ffffff;
              border: 1px solid #dcdcdc;
              border-radius: 5px;
              line-height: 92px;
              flex: 0 0 46%;
              padding: 0 24px;
              box-sizing: border-box;
              margin-bottom: 10px;
              position: relative;
              img {
                width: 80px;
                height: 28px;
                position: absolute;
                top: -15px;
                left: -2px;
              }
              &:hover {
                border: 2px solid #e6c29c;
              }
              &:nth-child(even) {
                margin-left: 10px;
              }
              .month {
                font-size: 20px;

                font-weight: 400;
                color: #333333;
                margin-right: 35px;
                width: 65px;
                display: inline-block;
                text-align: left;
              }
              .price {
                font-size: 14px;

                font-weight: 400;
                text-decoration: line-through;
                color: #999999;
                margin-right: 5px;
                display: inline-block;
                width: 40px;
                text-align: right;
              }
              .sale {
                font-size: 20px;

                font-weight: bold;
                color: #a45e1a;
                display: inline-block;
                text-align: right;
                width: 60px;
              }
            }
          }
          .name {
            border-left: 2px solid #b57230;
            color: #333;
            font-size: 16px;
            padding-left: 10px;
            width: 200px;
            display: inline-block;
          }
          .more {
            font-size: 14px;
            font-weight: 400;
            color: #a45e1a;
            width: 197px;
            height: 34px;
            background: #ffeedc;
            border-radius: 17px;
            float: right;
            cursor: pointer;
          }
        }
        .right {
          width: 250px;
          display: inline-block;
          padding-left: 40px;
          box-sizing: border-box;
          vertical-align: top;
          /deep/.is-active {
            border-color: #0f4d72;
          }
          /deep/.el-checkbox__inner:hover {
            border-color: #0f4d72;
          }
          /deep/ .is-checked {
            .el-checkbox__label {
              color: #666666;
            }
            .is-checked {
              .el-checkbox__inner {
                background-color: #0f4d72;
                border-color: #0f4d72;
              }
            }
          }
          button {
            width: 220px;
            height: 40px;

            border-radius: 5px;
            color: #63370c;
            font-weight: 400;
            margin-top: 38px;
            margin-bottom: 10px;
            cursor: pointer;
            font-size: 16px;
          }
          .ljbtn {
            background: linear-gradient(90deg, #f8ddbf, #d9b084);
            &:hover {
              background: linear-gradient(90deg, #f0cba2, #cc9963);
            }
          }
          .activeBtn {
            background: #dcdcdc;
            color: #bbb;
            cursor: not-allowed;
          }
          a {
            color: #0f4d72;
            text-decoration: underline;
          }
          ul {
            margin-top: 20px;
            li {
              display: flex;
              justify-content: space-between;
              width: 220px;
              margin-bottom: 15px;
              .txt1 {
                font-size: 14px;

                font-weight: 400;
                color: #666666;
              }
              .txt2 {
                font-size: 14px;

                font-weight: 400;
                color: #333333;
              }
            }
          }
          .user {
            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              vertical-align: middle;
            }
            .info {
              display: inline-block;
              vertical-align: middle;
              margin-left: 10px;
              .name {
                font-size: 16px;

                font-weight: 400;
                color: #333333;
                margin-bottom: 8px;
              }
              .grade {
                font-size: 14px;
                font-weight: 400;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
</style>